export function timeMinutes(value) {
  const match = /^(\d{2}):(\d{2})(?::\d{2})?$/.exec(String(value || ''));
  if (!match || Number(match[1]) > 23 || Number(match[2]) > 59) return null;
  return Number(match[1]) * 60 + Number(match[2]);
}

// Keep every meeting visible: overlapping courses get independent vertical lanes.
export function buildRoomTimetable(subjects) {
  const days = Array.from({ length: 7 }, (_, index) => ({ day: String(index + 1), events: [], lanes: 1 }));
  let start = 8 * 60;
  let end = 21 * 60;
  subjects.forEach(subject => {
    const seen = new Set();
    (subject.teach_days || []).forEach(meeting => {
      const from = timeMinutes(meeting.time);
      const to = timeMinutes(meeting.time2);
      const day = days[Number(meeting.day) - 1];
      const key = `${subject.row_key}-${meeting.day}-${from}-${to}`;
      if (!day || from === null || to === null || to <= from || seen.has(key)) return;
      seen.add(key);
      start = Math.min(start, Math.floor(from / 60) * 60);
      end = Math.max(end, Math.ceil(to / 60) * 60);
      day.events.push({ key, subject, meeting, start: from, end: to });
    });
  });
  days.forEach(day => {
    const ends = [];
    day.events.sort((a, b) => a.start - b.start || b.end - a.end || a.key.localeCompare(b.key));
    day.events.forEach(event => {
      let lane = ends.findIndex(value => value <= event.start);
      if (lane < 0) lane = ends.length;
      ends[lane] = event.end;
      event.style = {
        left: `${((event.start - start) / (end - start)) * 100}%`,
        width: `${((event.end - event.start) / (end - start)) * 100}%`,
        top: `${lane * 86 - 1}px`,
        height: '88px',
      };
    });
    day.lanes = Math.max(1, ends.length);
    day.height = day.events.length ? day.lanes * 86 : 54;
  });
  return { days, startHour: start / 60, endHour: end / 60 };
}
